import * as React from 'react';

export function ArrowDownIcon({
  width = 24,
  height = 24,
  color = 'currentColor',
}) {
  return (
    <svg
      height={height}
      width={width}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 17.9782L19.2716 11.3146L20.728 12.6854L11.9998 21.9591L3.27163 12.6854L4.72803 11.3146L11 17.9786L11 2L13 2L13 17.9782Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
}
